// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-SongRequests-module__videoPlayerPanel-tVpXA {
  overflow: hidden;
  padding: 0px;
  border: none;
}

@media (min-width: 768px) {

.nightbot-SongRequests-module__videoPlayerPanel-tVpXA {
    flex: 1;
}
  }

.nightbot-SongRequests-module__songRequestsTablePanel-TlJwz {
  flex: 1;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-bottom: none;
}

.nightbot-SongRequests-module__songRequestSettingsButton-IO1DT {
  width: 36px;
  height: 36px;
}

.nightbot-SongRequests-module__videoPlayerBanner-j5S8c {
  display: flex;
  gap: 48px;
  flex-direction: row;
}

@media (max-width: 768px) {

.nightbot-SongRequests-module__videoPlayerBanner-j5S8c {
    flex-direction: column;
    gap: 24px;
}
  }

.nightbot-SongRequests-module__videoPlayerBannerEmpty-AhBnX {
  display: none;
}

.nightbot-SongRequests-module__songRequestTableContainer-YgJSO {
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
}

.nightbot-SongRequests-module__songRequestControls-P56xD {
  position: sticky;
  bottom: 0;
  border-left-width: 1px;
  border-right-width: 1px;
  border-color: var(--border-primary);
  background-color: var(--background-primary);
}

.nightbot-SongRequests-module__youtubeVideoDescription-RiQtC {
  flex: 1;
}

.nightbot-SongRequests-module__soundcloudVideoDescription-ydl6H {
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/SongRequests.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;AAKd;;AAHE;;AALF;IAMI,OAAO;AAEX;EADE;;AAGF;EACE,OAAO;EACP,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AAMrB;;AAJE;;AALF;IAMI,sBAAsB;IACtB,SAAS;AAEb;EADE;;AAGF;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT","sourcesContent":[".videoPlayerPanel {\n  overflow: hidden;\n  padding: 0px;\n  border: none;\n\n  @media (min-width: $mantine-breakpoint-sm) {\n    flex: 1;\n  }\n}\n\n.songRequestsTablePanel {\n  flex: 1;\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-bottom: none;\n}\n\n.songRequestSettingsButton {\n  width: 36px;\n  height: 36px;\n}\n\n.videoPlayerBanner {\n  display: flex;\n  gap: 48px;\n  flex-direction: row;\n\n  @media (max-width: $mantine-breakpoint-sm) {\n    flex-direction: column;\n    gap: 24px;\n  }\n}\n\n.videoPlayerBannerEmpty {\n  display: none;\n}\n\n.songRequestTableContainer {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  position: relative;\n}\n\n.songRequestControls {\n  position: sticky;\n  bottom: 0;\n  border-left-width: 1px;\n  border-right-width: 1px;\n  border-color: var(--border-primary);\n  background-color: var(--background-primary);\n}\n\n.youtubeVideoDescription {\n  flex: 1;\n}\n\n.soundcloudVideoDescription {\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoPlayerPanel": `nightbot-SongRequests-module__videoPlayerPanel-tVpXA`,
	"songRequestsTablePanel": `nightbot-SongRequests-module__songRequestsTablePanel-TlJwz`,
	"songRequestSettingsButton": `nightbot-SongRequests-module__songRequestSettingsButton-IO1DT`,
	"videoPlayerBanner": `nightbot-SongRequests-module__videoPlayerBanner-j5S8c`,
	"videoPlayerBannerEmpty": `nightbot-SongRequests-module__videoPlayerBannerEmpty-AhBnX`,
	"songRequestTableContainer": `nightbot-SongRequests-module__songRequestTableContainer-YgJSO`,
	"songRequestControls": `nightbot-SongRequests-module__songRequestControls-P56xD`,
	"youtubeVideoDescription": `nightbot-SongRequests-module__youtubeVideoDescription-RiQtC`,
	"soundcloudVideoDescription": `nightbot-SongRequests-module__soundcloudVideoDescription-ydl6H`
};
export default ___CSS_LOADER_EXPORT___;
